export function normalise(str: string): string {
  return str.trim();
}

export function sortCaseInsensitive(a: string, b: string): number {
  return a.localeCompare(b, undefined, { sensitivity: 'base', numeric: true });
}

export function uniqueSorted(values: string[]): string[] {
  const set = new Set(values.map((v) => normalise(v)).filter(Boolean));
  return Array.from(set).sort(sortCaseInsensitive);
}

export function arraysEqual(a: string[], b: string[]): boolean {
  if (a === b) return true;
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; i += 1) {
    if (a[i] !== b[i]) return false;
  }
  return true;
}

export function equalIgnoringCaseAndSpaces(a: string, b: string): boolean {
  const na = a.replace(/\s+/g, '').toLowerCase();
  const nb = b.replace(/\s+/g, '').toLowerCase();
  return na === nb;
}

export function isLikelyPluralization(from: string, to: string): boolean {
  const f = from.trim();
  const t = to.trim();
  if (!f || !t) return false;
  const lowerF = f.toLowerCase();
  const lowerT = t.toLowerCase();
  // singular -> plural
  if (lowerT === `${lowerF}s`) return true;
  if (lowerF.endsWith('y') && lowerT === `${lowerF.slice(0, -1)}ies`)
    return true;
  if (lowerT === `${lowerF}es`) return true;
  // plural -> singular (symmetric)
  if (lowerF === `${lowerT}s`) return true;
  if (lowerT.endsWith('y') && lowerF === `${lowerT.slice(0, -1)}ies`)
    return true;
  if (lowerF === `${lowerT}es`) return true;
  return false;
}

export function deriveTypesFromText(
  text: string,
  sortMode: 'alpha' | 'manual',
  excludeOther = true
): string[] {
  const lines = text
    .split('\n')
    .map((l) => l.trim())
    .filter(Boolean)
    .filter((t) => (excludeOther ? t.toLowerCase() !== 'other' : true));
  if (sortMode === 'alpha') {
    return uniqueSorted(lines);
  }
  const seen = new Set<string>();
  const out: string[] = [];
  for (const v of lines) {
    if (!seen.has(v)) {
      seen.add(v);
      out.push(v);
    }
  }
  return out;
}
